export const Logo = ({ className = "h-12" }) => (
  <img
    src="/res/logo.png"
    alt="abc guitar lessons"
    data-testid="site-logo"
    className={`${className} w-auto`}
  />
);
